import React, { useState } from 'react';
import ReactDOM from 'react-dom/client'; // <-- import for React 18+

type EmailModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (email: string) => void;
};

export const EmailModal: React.FC<EmailModalProps> = ({ isOpen, onClose, onSubmit }) => {
  const [email, setEmail] = useState('');

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
    >
      <div style={{ background: '#fff', padding: 24, borderRadius: 8, minWidth: 300 }}>
        <h2>Enter your email</h2>
        <br />
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ width: '100%', marginBottom: 16, padding: 8 }}
          placeholder="Email"
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button onClick={onClose}>Cancel</button>
          <button
            onClick={() => {
              onSubmit(email);
              setEmail('');
            }}
            disabled={!email}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
};

// Usage helper to "pause" until OK is pressed
export function showEmailModal(): Promise<string | null> {
  return new Promise((resolve) => {
    const modalRoot = document.createElement('div');
    document.body.appendChild(modalRoot);

    const root = ReactDOM.createRoot(modalRoot);

    function cleanup() {
      root.unmount();
      document.body.removeChild(modalRoot);
    }

    const handleClose = () => {
      cleanup();
      resolve(null);
    };

    const handleSubmit = (email: string) => {
      cleanup();
      resolve(email);
    };

    root.render(<EmailModal isOpen onClose={handleClose} onSubmit={handleSubmit} />);
  });
}
